import React from 'react'
import { Row, Col, Divider, Form } from 'antd'
import { RuleFormFields } from './RuleFormFields'
import { AudienceField } from './AudienceField'
import { LivePreview } from './LivePreview'
import { TokenChips } from './TokenChips'
import { EVENT_OPTIONS } from './catalog'

/** The visual rule builder: guided fields (left) + a live preview (right). */
export function RuleStudio() {
  const form = Form.useFormInstance()
  const triggerEvent = Form.useWatch('trigger_event', form) as string | undefined
  const tokens = EVENT_OPTIONS.find((e) => e.value === triggerEvent)?.placeholders ?? []

  return (
    <Row gutter={24}>
      <Col xs={24} lg={15}>
        <RuleFormFields />
        <Divider orientation="left">Who it's tied to</Divider>
        <AudienceField namePath={['activity_template', 'audience']} />
        <Divider orientation="left">Insert a placeholder</Divider>
        <TokenChips tokens={tokens} targetPath={['activity_template', 'text_template']} />
      </Col>
      <Col xs={24} lg={9}>
        <LivePreview />
      </Col>
    </Row>
  )
}
